import { render } from "./view_chat.vue?vue&type=template&id=defb4aac&scoped=true"
import script from "./view_chat.vue?vue&type=script&lang=js"
export * from "./view_chat.vue?vue&type=script&lang=js"

import "./view_chat.vue?vue&type=style&index=0&id=defb4aac&scoped=true&lang=css"

import exportComponent from "E:\\work\\code\\ai-view\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-defb4aac"]])

export default __exports__